import { dividerPropsSchema } from '../component-catalog.js';
export const dividerDefinition = {
    type: 'Divider',
    category: 'layout',
    propsSchema: dividerPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Visual separator between sections. Props: orientation? ("horizontal" | "vertical").',
};
//# sourceMappingURL=Divider.js.map